import axios from 'axios';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const updateFaq = async (payload: any) => {
    const { data } = await axios.put(Apis.UPDATE_FAQS, payload, { headers: { Authorization: getToken() } });
    return data;
};
export default updateFaq;
